import TrialStickyBanner from "components/billing/TrialStickyBanner";
import AppUpdateBanner from "components/layouts/AppUpdateBanner";
import isDarkModeSupportedPage from "components/ux/isDarkModeSupportedPage";
import useSelfie from "lib/hooks/useSelfie";
import { ThemeProvider } from "next-themes";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import { parseAsStringLiteral, useQueryState } from "nuqs";
import type { ReactNode } from "react";
import { IUserSettingsV2Theme } from "types/graphqlTypes";

interface IsolatedLayoutProps {
  forcedTheme?: "light" | "dark";
  children: ReactNode;
}

export default function IsolatedLayout({ forcedTheme, children }: IsolatedLayoutProps) {
  const viewer = useSelfie();
  const pathname = usePathname();
  const router = useRouter();
  const [currentThemeFromUrl] = useQueryState("theme", parseAsStringLiteral(["light", "dark"]).withDefault("light"));
  return (
    <ThemeProvider
      forcedTheme={(() => {
        if (forcedTheme) {
          return forcedTheme;
        }
        // We're not there yet
        if (!viewer && pathname === "/") {
          return "light";
        }
        if (!isDarkModeSupportedPage(pathname) && !isDarkModeSupportedPage(router.pathname)) {
          return "light";
        }

        if (viewer) {
          return viewer?.settingsV2.theme === IUserSettingsV2Theme.Dark ? "dark" : "light";
        }

        return currentThemeFromUrl;
      })()}
      enableSystem={false}
      attribute="class"
      disableTransitionOnChange={true}
    >
      {process.env.NODE_ENV === "production" && <AppUpdateBanner disabled={true} />}
      {viewer?.isTrialing && pathname !== "/thank-you" && <TrialStickyBanner />}
      {children}
    </ThemeProvider>
  );
}
